import { HubConnectionBuilder } from "@aspnet/signalr";
import { appSettings } from "@/settings";
import { Vue } from "vue-property-decorator";
import DispatcherHub from "@/hubs/DispatcherHub";
import DispatcherHubEvent from "@/models/Dispatcher/DispatcherHubEvent";
import { tokenStore } from "@/store";

export default {
  install() {
    const connection = new HubConnectionBuilder()
      .withUrl(`${appSettings.BaseApiUrl}hubs/dispatcherHub`, {
        accessTokenFactory: () => {
          const token = tokenStore.get();

          if (!token || !token.value) {
            return "";
          }

          return token.value;
        },
      })
      .build();

    const dispatcherHub = new DispatcherHub(connection);

    Vue.prototype.$dispatcherHub = dispatcherHub;

    for (const event in DispatcherHubEvent) {
      connection.on(
        DispatcherHubEvent[event as keyof typeof DispatcherHubEvent],
        (arg) => {
          dispatcherHub.$emit(
            DispatcherHubEvent[event as keyof typeof DispatcherHubEvent],
            arg
          );
        }
      );
    }

    // if connection closed, reopen it
    let startedPromise: null | Promise<any> = null;

    function start(): Promise<any> {
      if (startedPromise) {
        return startedPromise;
      }

      startedPromise = connection
        .start()
        .then(() => {
          dispatcherHub.connected = true;
          startedPromise = null;
          dispatcherHub.$emit("connected");
        })
        .catch(() => {
          dispatcherHub.connected = false;
          startedPromise = null;

          return new Promise((resolve, reject) =>
            setTimeout(() => start().then(resolve).catch(reject), 5000)
          );
        });

      return startedPromise;
    }

    connection.onclose(() => {
      dispatcherHub.connected = false;
      dispatcherHub.$emit("disconnected");
      start();
    });

    start();
  },
};
